





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseRangeSlider from "@/app/shared/components/base/BaseRangeSlider.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInputColor from "@/app/shared/components/base/BaseInputColor.vue";
import BaseInputCircleColor from "@/app/shared/components/base/BaseInputCircleColor.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseInputStepping from "@/app/shared/components/base/BaseInputStepping.vue";
import BaseInputEasy from "@/app/shared/components/base/BaseInputEasy.vue";
import BaseInputEasySlider from "@/app/shared/components/base/BaseInputEasySlider.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";
import BasePositionCheckbox from "@/app/shared/components/base/BasePositionCheckbox.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";
import draggable from "vuedraggable";
import BaseSelect from "@/app/shared/components/base/BaseSelect.vue";
import BaseSelectFooter from "@/app/shared/components/base/BaseSelectFooter.vue";
import { VPopover, VClosePopover } from "v-tooltip";
import BaseColorpicker from "@/app/shared/components/base/BaseColorpicker.vue";
import utils from "@/app/shared/utils/utils.js";

export default Vue.extend({
  name: "OverlayCard",
  components: {
    BaseSimpleSlider,
    BaseRangeSlider,
    BaseButton,
    BaseInputColor,
    BaseInputCircleColor,
    BaseInput,
    BaseInputStepping,
    BaseInputEasy,
    BaseInputEasySlider,
    BaseSearchInput,
    BaseCheckbox,
    BasePositionCheckbox,
    draggable,
    BaseSelect,
    BaseSelectFooter,
    VPopover,
    BaseColorpicker,
    BaseAnimation,
  },
  mixins: [utils],
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      drag: false,
      durationAccuracy: 1000,
      animationsIn: [
        { id: "default-0", name: "none", title: "None", animateAlpha: false },
        { id: "default-1", name: "alpha", title: "Alpha", animateAlpha: true },
        {
          id: "default-2",
          name: "motion-left",
          title: "Motion Left",
          animateAlpha: false,
        },
        {
          id: "default-3",
          name: "motion-left",
          title: "Motion Left Alpha",
          animateAlpha: true,
        },
        {
          id: "default-4",
          name: "motion-right",
          title: "Motion Right",
          animateAlpha: false,
        },
        {
          id: "default-5",
          name: "motion-right",
          title: "Motion Right Alpha",
          animateAlpha: true,
        },
        {
          id: "default-6",
          name: "motion-up",
          title: "Motion Up",
          animateAlpha: false,
        },
        {
          id: "default-7",
          name: "motion-up",
          title: "Motion Up Alpha",
          animateAlpha: true,
        },
        {
          id: "default-8",
          name: "motion-down",
          title: "Motion Down",
          animateAlpha: false,
        },
        {
          id: "default-9",
          name: "motion-down",
          title: "Motion Down Alpha",
          animateAlpha: true,
        },
        /*         {
          id: "default-10",
          name: "zoom-in",
          title: "Zoom In",
          animateAlpha: false,
        },
        {
          id: "default-11",
          name: "zoom-in",
          title: "Zoom In Alpha",
          animateAlpha: true,
        }, */
      ],
      animationsOut: [
        { id: "default-0", name: "none", title: "None", animateAlpha: false },
        { id: "default-1", name: "alpha", title: "Alpha", animateAlpha: true },
        {
          id: "default-2",
          name: "motion-left",
          title: "Motion Left",
          animateAlpha: false,
        },
        {
          id: "default-3",
          name: "motion-left",
          title: "Motion Left Alpha",
          animateAlpha: true,
        },
        {
          id: "default-4",
          name: "motion-right",
          title: "Motion Right",
          animateAlpha: false,
        },
        {
          id: "default-5",
          name: "motion-right",
          title: "Motion Right Alpha",
          animateAlpha: true,
        },
        {
          id: "default-6",
          name: "motion-up",
          title: "Motion Up",
          animateAlpha: false,
        },
        {
          id: "default-7",
          name: "motion-up",
          title: "Motion Up Alpha",
          animateAlpha: true,
        },
        {
          id: "default-8",
          name: "motion-down",
          title: "Motion Down",
          animateAlpha: false,
        },
        {
          id: "default-9",
          name: "motion-down",
          title: "Motion Down Alpha",
          animateAlpha: true,
        },
        /*         {
          id: "default-12",
          name: "zoom-out",
          title: "Zoom Out",
          animateAlpha: false,
        },
        {
          id: "default-13",
          name: "zoom-out",
          title: "Zoom Out Alpha",
          animateAlpha: true,
        }, */
      ],
      positions: {
        leftTop: "left-top",
        leftTopBorder: "left-top-border",
        centerTop: "center-top",
        centerTopBottom: "center-top-border",
        rightTop: "right-top",
        rightTopBorder: "right-top-border",
        leftCenter: "left-center",
        leftCenterBorder: "left-center-border",
        center: "center",
        rightCenter: "right-center",
        rightCenterBorder: "right-center-border",
        leftBottom: "left-bottom",
        leftBottomBorder: "left-bottom-border",
        centerBottom: "center-bottom",
        centerBottomBorder: "center-bottom-border",
        rightBottom: "right-bottom",
        rightBottomBorder: "right-bottom-border",
      },
      hoveredOverlayId: "",
      hoverSizeSelect: "",
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
    overlay: {
      type: Object,
      required: true,
    },
    fonts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
  },
  watch: {},
  created() {},
  methods: {
    updateAnimation(overlayId) {
      $eventsBus.$emit("updateAnimation", overlayId);
    },
    switchLayer(overlay, layer) {
      if (
        layer.hasOwnProperty("opacity") &&
        layer.hasOwnProperty("isVisible")
      ) {
        if (layer.isVisible) {
          layer.tempValue = overlay.getAnimationPropAtPath(
            overlay.file.json,
            layer.opacity.path
          );
          layer.isVisible = false;
          this.changeOpacityAnimation(0, overlay, layer);
        } else {
          layer.isVisible = true;
          this.changeOpacityAnimation(layer.tempValue, overlay, layer);
        }

        this.changeCheckedItems(overlay, {
          callbackChangeAnimationCheckedItems: (twinOverlay) => {
            const twinLayer = twinOverlay.file.layers.find(
              (l) => l.id === layer.id
            );
            twinLayer.tempValue = twinOverlay.getAnimationPropAtPath(
              twinOverlay.file.json,
              layer.opacity.path
            );
            twinLayer.isVisible = layer.isVisible;
          },
        });
      }
    },
    isHoverSizeSelect(overlayId, layerId) {
      return this.hoverSizeSelect === overlayId + layerId;
    },
    onMouseOverSizeSelect(overlayId, layerId) {
      this.hoverSizeSelect = overlayId + layerId;
    },
    onMouseLeaveSizeSelect(overlayId, layerId) {
      this.hoverSizeSelect = "";
    },
    updateAnimationLayerColor(hex, overlay, fileAnimation, pathString) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      const colorRGB = result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
          ]
        : [0, 0, 0];
      const colorArrFraction = colorRGB.map((item) => item / 255);

      const pathAndLastKey = overlay.getPathAndLastKeyAnimationProp(
        fileAnimation,
        pathString
      );
      const currentColor = pathAndLastKey.path[pathAndLastKey.key];
      [currentColor[0], currentColor[1], currentColor[2]] = colorArrFraction;
    },
    getSize(min, max, defaultValue) {
      return [
        Math.round((defaultValue - min) / 3),
        Math.round(((defaultValue - min) / 3) * 2),
        defaultValue,
        Math.round((max - defaultValue) / 3 + defaultValue),
        Math.round(((max - defaultValue) / 3) * 2 + defaultValue),
        max,
      ];
    },
    changeTextCenterAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        val,
        overlay,
        overlay.file.json,
        layer.text.path
      );
      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.text.path
          );
        },
      });

      // Обновление названия оверлея
      // При добавлении других возможных текстов (Например, не Centr, а Left, Right) Вынести в отдельную функцию
      if (layer.text?.isTitle) {
        overlay.file.name = overlay.getAnimationPropAtPath(
          overlay.file.json,
          layer.text.path
        );

        this.changeCheckedItems(overlay, {
          callbackChangeAnimationCheckedItems: (twinOverlay) => {
            twinOverlay.file.name = twinOverlay.getAnimationPropAtPath(
              twinOverlay.file.json,
              layer.text.path
            );
          },
        });
      }
    },

    changeInscribeTextInWidthAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        val,
        overlay,
        overlay.file.json,
        layer.text.path
      );

      const findTextSize = (size) => {
        if (
          size *
            layer.text.coef *
            overlay.getAnimationPropAtPath(overlay.file.json, layer.text.path)
              .length >
          layer.text.maxWidth
        ) {
          return findTextSize(size - 1);
        } else {
          return size;
        }
      };

      const newTextSize = findTextSize(layer.size.max);

      overlay.updatePropInAnimationPath(
        newTextSize,
        overlay,
        overlay.file.json,
        layer.size.path
      );

      overlay.updatePropInAnimationPath(
        (overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) /
          layer.size.defaultValue) *
          layer.bottomPadding.defaultValue,
        overlay,
        overlay.file.json,
        layer.bottomPadding.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          twinOverlay.updatePropInAnimationPath(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.text.path
          );

          twinOverlay.updatePropInAnimationPath(
            newTextSize,
            twinOverlay,
            twinOverlay.file.json,
            layer.size.path
          );

          twinOverlay.updatePropInAnimationPath(
            (twinOverlay.getAnimationPropAtPath(
              twinOverlay.file.json,
              layer.size.path
            ) /
              layer.size.defaultValue) *
              layer.bottomPadding.defaultValue,
            twinOverlay,
            twinOverlay.file.json,
            layer.bottomPadding.path
          );
        },
      });

      // Обновление названия оверлея
      // При добавлении других возможных текстов (Например, не Centr, а Left, Right) Вынести в отдельную функцию
      if (layer.text?.isTitle) {
        overlay.file.name = overlay.getAnimationPropAtPath(
          overlay.file.json,
          layer.text.path
        );

        this.changeCheckedItems(overlay, {
          callbackChangeAnimationCheckedItems: (twinOverlay) => {
            twinOverlay.file.name = twinOverlay.getAnimationPropAtPath(
              twinOverlay.file.json,
              layer.text.path
            );
          },
        });
      }
    },

    changeSizeTextCenterAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        val,
        overlay,
        overlay.file.json,
        layer.size.path
      );

      overlay.updatePropInAnimationPath(
        (overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) /
          layer.size.defaultValue) *
          layer.bottomPadding.defaultValue,
        overlay,
        overlay.file.json,
        layer.bottomPadding.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.size.path
          );

          overlay.updatePropInAnimationPath(
            (overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.size.path
            ) /
              layer.size.defaultValue) *
              layer.bottomPadding.defaultValue,
            twinOverlay,
            twinOverlay.file.json,
            layer.bottomPadding.path
          );
        },
      });
    },

    changeSizeUpTextCenterAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) +
          step,
        overlay,
        overlay.file.json,
        layer.size.path
      );

      overlay.updatePropInAnimationPath(
        ((overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) +
          step) /
          layer.size.defaultValue) *
          layer.bottomPadding.defaultValue,
        overlay,
        overlay.file.json,
        layer.bottomPadding.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) +
              step,
            twinOverlay,
            twinOverlay.file.json,
            layer.size.path
          );

          overlay.updatePropInAnimationPath(
            ((overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.size.path
            ) +
              step) /
              layer.size.defaultValue) *
              layer.bottomPadding.defaultValue,
            twinOverlay,
            twinOverlay.file.json,
            layer.bottomPadding.path
          );
        },
      });
    },
    changeSizeDownTextCenterAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) -
          step,
        overlay,
        overlay.file.json,
        layer.size.path
      );

      overlay.updatePropInAnimationPath(
        ((overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) -
          step) /
          layer.size.defaultValue) *
          layer.bottomPadding.defaultValue,
        overlay,
        overlay.file.json,
        layer.bottomPadding.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(overlay.file.json, layer.size.path) -
              step,
            twinOverlay,
            twinOverlay.file.json,
            layer.size.path
          );

          overlay.updatePropInAnimationPath(
            ((overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.size.path
            ) -
              step) /
              layer.size.defaultValue) *
              layer.bottomPadding.defaultValue,
            twinOverlay,
            twinOverlay.file.json,
            layer.bottomPadding.path
          );
        },
      });
    },

    changeBorderRadiusAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        (val / 100) * layer.radius.max,
        overlay,
        overlay.file.json,
        layer.radius.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            (val / 100) * layer.radius.max,
            twinOverlay,
            twinOverlay.file.json,
            layer.radius.path
          );
        },
      });
    },
    changeBorderRadiusUpAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        (((overlay.getAnimationPropAtPath(
          overlay.file.json,
          layer.radius.path
        ) /
          layer.radius.max) *
          100 +
          step) /
          100) *
          layer.radius.max,
        overlay,
        overlay.file.json,
        layer.radius.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            (((overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.radius.path
            ) /
              layer.radius.max) *
              100 +
              step) /
              100) *
              layer.radius.max,
            twinOverlay,
            twinOverlay.file.json,
            layer.radius.path
          );
        },
      });
    },
    changeBorderRadiusDownAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        (((overlay.getAnimationPropAtPath(
          overlay.file.json,
          layer.radius.path
        ) /
          layer.radius.max) *
          100 -
          step) /
          100) *
          layer.radius.max,
        overlay,
        overlay.file.json,
        layer.radius.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            (((overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.radius.path
            ) /
              layer.radius.max) *
              100 -
              step) /
              100) *
              layer.radius.max,
            twinOverlay,
            twinOverlay.file.json,
            layer.radius.path
          );
        },
      });
    },
    changeLineWidthAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        val,
        overlay,
        overlay.file.json,
        layer.width.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.width.path
          );
        },
      });
    },
    changeLineWidthUpAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.width.path) +
          step,
        overlay,
        overlay.file.json,
        layer.width.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.width.path
            ) + step,
            twinOverlay,
            twinOverlay.file.json,
            layer.width.path
          );
        },
      });
    },
    changeLineWidthDownAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.width.path) -
          step,
        overlay,
        overlay.file.json,
        layer.width.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.width.path
            ) - step,
            twinOverlay,
            twinOverlay.file.json,
            layer.width.path
          );
        },
      });
    },
    changePointsAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        val,
        overlay,
        overlay.file.json,
        layer.points.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.points.path
          );
        },
      });
    },
    changePointsUpAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.points.path) +
          step,
        overlay,
        overlay.file.json,
        layer.points.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.width.path
            ) + step,
            twinOverlay,
            twinOverlay.file.json,
            layer.points.path
          );
        },
      });
    },
    changePointsDownAnimation(overlay, layer, step) {
      overlay.updatePropInAnimationPath(
        overlay.getAnimationPropAtPath(overlay.file.json, layer.points.path) -
          step,
        overlay,
        overlay.file.json,
        layer.points.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            overlay.getAnimationPropAtPath(
              overlay.file.json,
              layer.points.path
            ) - step,
            twinOverlay,
            twinOverlay.file.json,
            layer.width.path
          );
        },
      });
    },
    changeColorAnimation(val, overlay, layer) {
      this.updateAnimationLayerColor(
        val,
        overlay,
        overlay.file.json,
        layer.color.path
      );
      // Жёсткое обновление оверлея для реактивного обновления цвета

      overlay.file = {
        ...overlay.file,
        file: { ...overlay.file.json },
      };

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          this.updateAnimationLayerColor(
            val,
            twinOverlay,
            twinOverlay.file.json,
            layer.color.path
          );
        },
      });
    },
    changeOpacityAnimation(val, overlay, layer) {
      overlay.updatePropInAnimationPath(
        parseInt(val),
        overlay,
        overlay.file.json,
        layer.opacity.path
      );

      this.updateAnimation(overlay.id);

      this.changeCheckedItems(overlay, {
        callbackChangeAnimationCheckedItems: (twinOverlay) => {
          overlay.updatePropInAnimationPath(
            parseInt(val),
            twinOverlay,
            twinOverlay.file.json,
            layer.opacity.path
          );
        },
      });
    },
    updateMoveables() {
      $eventsBus.$emit("updateAllMoveables");
    },
    clickPosition(overlay, positionName) {
      this.$emit("changeOverlayPosition", overlay, positionName, true);
      this.updateMoveables();
      this.$store.commit("addNewStateToHistory");
    },
    onMouseOverOverlay(overlay) {
      this.hoveredOverlayId = overlay.id;
    },
    onMouseLeaveOverlay(overlay) {
      this.hoveredOverlayId = "";
    },
    changeOverlayTime(overlay, val) {
      let val0 = val[0];
      let val1 = val[1];
      if (overlay.startTime === val0 && overlay.finishTime === val1) {
        return;
      }
      overlay.startTime = val0;
      overlay.finishTime = val1;
      if (
        this.isOverlayDurationCanMultiselectEdit(
          this.previewItem.currentVariation,
          overlay
        )
      ) {
        this.changeCheckedItems(overlay, {
          isDuration: true,
        });
      }
      this.updateMoveables();
      this.$store.commit("addNewStateToHistory");
      $eventsBus.$emit(
        "updateAllDurationForAnimation",
        overlay,
        this.previewItem.currentVariation.speed,
        val
      );
    },
    changeBoxWidth(overlay, value) {
      overlay.style.box.width = value;
      this.updateMoveables();
      setTimeout(() => {
        this.changeCheckedItems(overlay, {
          isBoxWidth: true,
        });
      }, 10);
    },
    clearOverlayTime(overlay) {
      overlay.startTime = 0;
      overlay.finishTime = this.previewItem.duration;
      this.$forceUpdate();
    },
    openOverlaysLibraryWindow(overlay?) {
      this.$store.commit("showOverlaysLibraryWindow", true);
      if (overlay) {
        setTimeout(() => {
          $eventsBus.$emit("editOverlay", overlay);
        }, 100);
      }
    },
    moveArrayItemToNewIndex(array, object, toIndex) {
      array.splice(toIndex, 0, array.splice(array.indexOf(object), 1)[0]);
    },
    shiftOverlayToTop() {
      this.$emit("shiftOverlayUp");
    },
    shiftOverlayToBottom() {
      this.$emit("shiftOverlayDown");
    },
    sendOverlayToBack() {
      this.$emit("sendOverlayToBack");
    },
    sendOverlayToFront() {
      this.$emit("sendOverlayToFront");
    },
    duplicateOverlay() {
      this.$emit("duplicateOverlay");
    },
    deleteOverlay() {
      this.$emit("deleteOverlay");
    },
    changeFont(overlay) {
      this.changeCheckedItems(overlay, {
        isFont: true,
      });
      this.updateMoveables();
      this.$store.commit("addNewStateToHistory");
    },
    loadNewFont(): void {
      this.$emit("loadNewFont");
    },
    deleteFont(font) {
      this.$emit("deleteFont", font);
    },
    //deprecated
    getOverlayTransform(overlay) {
      let transforms = overlay.transforms;
      return (
        "translate(" +
        (transforms.translateX ? transforms.translateX : 0) +
        "px, " +
        (transforms.translateY ? transforms.translateY : 0) +
        "px) " +
        "rotate(" +
        (transforms.rotate ? transforms.rotate : 0) +
        "deg) scale3d(" +
        (transforms.scaleX ? transforms.scaleX : 1) +
        ", " +
        (transforms.scaleY ? transforms.scaleY : 1) +
        ", 1)"
      );
    },
    fitInText(overlay) {
      overlay.moveabaleStyle.width = "100%";
      this.changeCheckedItems(overlay, {
        isMoveabaleStyleWidth: true,
      });
      let newPosition = "";
      switch (overlay.position) {
        case "left-top":
        case "center-top":
        case "right-top":
          newPosition = "center-top";
          break;
        case "left-center":
        case "center":
        case "right-center":
          newPosition = "center";
          break;
        case "left-bottom":
        case "center-bottom":
        case "right-bottom":
          newPosition = "center-bottom";
          break;
      }
      this.$emit("changeOverlayPosition", overlay, newPosition, true);
      this.updateMoveables();
    },
    changeCheckedItems(overlay, optionsToChange) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked)
        .forEach((v) => {
          v.getAllOverlays()
            .filter((o) => {
              return (
                (this.isItTextObject(overlay)
                  ? o.value === overlay.value
                  : this.isItAnimationObject(overlay)
                  ? o?.file?.id && o.file.id === overlay.file.id
                  : JSON.stringify(o.file) ===
                    JSON.stringify(overlay.file)) /*TODO need check it */ &&
                o.id !== overlay.id &&
                o.twinnedId === overlay.twinnedId
                /*                 this.getOverlayTransform(o) ===
                  this.getOverlayTransform(overlay) &&
                (oldPosition
                  ? o.position === oldPosition
                  : o.position === overlay.position) */
              );
            })
            .forEach((o) => {
              if (!!optionsToChange.isOpacity) {
                if (this.isItTextObject(overlay)) {
                  o.style.opacity = overlay.style.opacity;
                } else {
                  o.alpha = overlay.alpha;
                }
              }
              if (!!optionsToChange.isColors) {
                o.style.color = overlay.style.color;
                if (this.isItTextObject(overlay)) {
                  o.style.box.color = overlay.style.box.color;
                }
              }
              if (!!optionsToChange.isFont) {
                o.style.font = overlay.style.font;
              }
              if (!!optionsToChange.isFontStyle) {
                o.style.fontWeight = overlay.style.fontWeight;
                o.style.fontStyle = overlay.style.fontStyle;
                o.style.isUnderline = overlay.style.isUnderline;
                o.style.paragraph = overlay.style.paragraph;
              }
              if (!!optionsToChange.isDuration) {
                o.startTime = overlay.startTime;
                o.finishTime = overlay.finishTime;
              }
              if (!!optionsToChange.isBoxWidth) {
                o.style.box.width = overlay.style.box.width;
              }

              if (!!optionsToChange.isMoveabaleStyleWidth) {
                o.moveabaleStyle.width = overlay.moveabaleStyle.width;
              }

              if (!!optionsToChange.isFadeIn) {
                o.animation.fadeIn.type = overlay.animation.fadeIn.type;
              }
              if (!!optionsToChange.isFadeOut) {
                o.animation.fadeOut.type = overlay.animation.fadeOut.type;
              }
              if (!!optionsToChange.callbackChangeAnimationCheckedItems) {
                optionsToChange.callbackChangeAnimationCheckedItems(o);
                this.updateAnimation(o.id);
              }
            });
        });
    },
    isItTextObject(overlayObject) {
      return overlayObject.type === "text";
    },
    isItShapeObject(overlayObject) {
      return overlayObject.type === "shape";
    },
    isItAnimationObject(overlayObject) {
      return overlayObject.type === "animation";
    },
    isOverlayCanMultiselectEdit(overlay) {
      if (!this.previewItem.currentVariation.checked) {
        return true;
      }
      return this.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked && v !== this.previewItem.currentVariation)
        .every((v) => {
          return v.getAllOverlays().some((o) => {
            return (
              (this.isItTextObject(overlay)
                ? o.value === overlay.value &&
                  o.isRectangle === overlay.isRectangle
                : this.isItAnimationObject(overlay)
                ? o?.file?.id && o.file.id === overlay.file.id
                : JSON.stringify(o.file) ===
                  JSON.stringify(overlay.file)) /*TODO need check it */ &&
              o.twinnedId === overlay.twinnedId
              /* this.getOverlayTransform(o) ===
                this.getOverlayTransform(overlay) &&
              o.position === overlay.position */
            );
          });
        });
    },
    isOverlayDurationCanMultiselectEdit(variation, overlay) {
      if (!this.previewItem.currentVariation.checked) {
        return true;
      }
      if (this.isOverlayCanMultiselectEdit(overlay)) {
        let itemsWithSomeCheckedVariations = this.$store.state.items.filter(
          (i) => i.variations.some((v) => v.checked)
        );
        return (
          !this.previewItem.currentVariation.checked ||
          (this.previewItem.currentVariation.checked &&
            itemsWithSomeCheckedVariations.length === 1)
        );
      } else {
        return false;
      }
    },
  },
});
